import React from 'react';
import { Disclosure, Transition } from '@headlessui/react';
import { CheckCircleIcon } from '@heroicons/react/20/solid';
import { pick } from 'lodash';
export type Detail = {
  title: React.ReactNode;
  state: 'current' | 'passed' | 'upcoming';
  badge?: React.ReactNode;
  [x: string]: any;
};
export interface IDisclosure {
  title: string;
  details: ReadonlyArray<Detail>;
  className?: string;
  defaultOpen?: boolean;
  onItemClick?: (arg1: IDisclosure['details'][number]) => void;
}

const CicleOrderedList = ({
  title,
  badge,
  state,
  onItemClick,
}: Detail & { onItemClick?: () => void }) => (
  <div
    className="flex px-4 pl-4 py-4 text-sm items-center cursor-pointer"
    onClick={onItemClick}
  >
    {state === 'passed' ? (
      <>
        <CheckCircleIcon className="h-5 w-5 flex-shrink-0 text-primary-600" />
        <span className="ml-2 text-sm font-medium text-primary-600">
          {title}
        </span>
      </>
    ) : (
      <>
        <span
          className={`flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full border-2 ${
            state === 'current'
              ? `text-primary-600 border-primary-600`
              : 'text-gray-300 border-gray-300'
          }`}
        >
          <span
            className={
              state === 'current'
                ? `text-primary-600 text-xs`
                : 'text-gray-600 text-xs'
            }
          >
            {badge}
          </span>
        </span>
        <span
          className={`ml-2 text-sm font-medium ${
            state === 'current' ? `text-primary-600` : 'text-gray-600'
          }`}
        >
          {title}
        </span>
      </>
    )}
  </div>
);

function Component(props: IDisclosure) {
  const { title, details, className, defaultOpen, onItemClick } = props;
  return (
    <Disclosure
      defaultOpen={defaultOpen}
      as="div"
      className={`max-w-md bg-white border rounded-lg overflow-hidden shadow ${
        className ?? ''
      }`}
    >
      {({ open }) => (
        <>
          <Disclosure.Button
            className={`flex w-full justify-between px-4 py-2 text-left text-sm font-medium hover:bg-gray-200 ${
              open ? 'hover:rounded-b-none' : ''
            } focus:outline-none`}
          >
            <span>{title}</span>
          </Disclosure.Button>
          <Transition
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            <Disclosure.Panel className="text-sm text-gray-500">
              <div className="bg-gray-50 divide-y divide-gray-200">
                {React.Children.toArray(
                  details.map((el, i) => (
                    <CicleOrderedList
                      onItemClick={() => {
                        onItemClick?.(el);
                      }}
                      title={el.title}
                      badge={el.badge ?? i + 1}
                      state={el.state}
                    />
                  ))
                )}
              </div>
            </Disclosure.Panel>
          </Transition>
        </>
      )}
    </Disclosure>
  );
}
export { Component as DisclosureUI };
